// extracted by mini-css-extract-plugin
export default {"container":"EmbargoBankAccountInfoRequestModal_container__5MH8t","file":"EmbargoBankAccountInfoRequestModal_file__gMdnk"};